export default __webpack_public_path__ + "static/media/Run (5).eaccf7fb.png";